import HTML from 'components/HTML';
import Modal, { useAlertModal } from 'components/Modal';
import { printf } from 'utils/i18n';

const service = 'support@tradeup.com';
const hintMessageList = [
    printf(
        __(
            'Should you have any questions or concerns, please contact our Customer Support team via Live Chat or %s for more information.'
        ),
        `<a href='mailto:${service}'>${service}</a>`
    )
];

export const useCaptchaErrorModal = () => {
    const { open: openAlertModal } = useAlertModal();

    return (error: any) => {
        if (error?.error_code === 11012) {
            openAlertModal({
                className: 'captcha-error-modal',
                content: (
                    <ol>
                        {hintMessageList.map((t, i) => (
                            <HTML as="li" key={i} html={t} />
                        ))}
                    </ol>
                )
            });
        } else {
            Modal.error({
                content: error.message
            });
        }
    };
};
